import { render, staticRenderFns } from "./custom-promised-alert-component.vue?vue&type=template&id=faa5143e"
import script from "./custom-promised-alert-component.vue?vue&type=script&lang=js"
export * from "./custom-promised-alert-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports